import { type PropsWithTestID } from "@boi/components-core";

import { type ResponsiveTableProps } from "../ResponsiveTable";
import { Table } from "../../Table";
import { TooltipPopoverV2 } from "../../TooltipPopoverV2";
import { TooltipIconButtonV2 } from "../../TooltipIconButtonV2";

export type StandardTableProps = PropsWithTestID &
  Pick<ResponsiveTableProps, "standardLayout" | "headers" | "rows">;

function StandardTable(props: StandardTableProps) {
  const { standardLayout, headers, rows, testID } = props;

  return (
    <Table layout={standardLayout} testID={`${testID}-standard`}>
      <Table.Thead>
        <Table.Tr data-testid={`${testID}-standard-row`}>
          {headers.map((header, headerIndex) => (
            <Table.Th
              key={headerIndex}
              align={header.align}
              data-testid={`${testID}-standard-header`}
            >
              {header.tooltip && (
                <TooltipPopoverV2>
                  <TooltipPopoverV2.Trigger>
                    <TooltipIconButtonV2
                      aria-label={`${header.text} tooltip`}
                    />

                    <TooltipPopoverV2.Content>
                      {header.tooltip}
                    </TooltipPopoverV2.Content>
                  </TooltipPopoverV2.Trigger>
                </TooltipPopoverV2>
              )}

              {header.text}
            </Table.Th>
          ))}
        </Table.Tr>
      </Table.Thead>

      <Table.Tbody>
        {rows.map((row, rowIndex) => (
          <Table.Tr key={rowIndex} data-testid={`${testID}-standard-row`}>
            {row.map((data, dataIndex) => (
              <Table.Td
                key={dataIndex}
                align={headers[dataIndex]?.align}
                data-testid={`${testID}-standard-data`}
              >
                {data.text}
              </Table.Td>
            ))}
          </Table.Tr>
        ))}
      </Table.Tbody>
    </Table>
  );
}

export default StandardTable;
